import * as Yup from 'yup'
import { messageHelper } from '../../../../../utils/messageHelper'

export const createTicketValidation = Yup.object({
  name: Yup.string()
    .min(1, 'Titulo do ingresso deve ter mínimo 2 caracteres.')
    .max(255, 'Titulo do ingresso deve ter menos do que 128 caracteres.')
    .required(messageHelper.yup.creator.nameIsMandatory),
  priceCents: Yup.string()
    .required('Preço é obrigatório')
    .test('priceTest', 'Preço deve ser maior do que 0', (value) => {
      if (value) {
        return Number(value.replace(/[^0-9]/g, '')) >= 0
      }
      return false
    }),
  type: Yup.string()
    .min(1, messageHelper.yup.creator.eventShortName)
    .max(800, messageHelper.yup.creator.eventLongName)
    .required(messageHelper.yup.creator.nameIsMandatory),
  rule: Yup.string().nullable()
})
